export default __webpack_public_path__ + "static/font-fc1b2a4dac05632ff57cf02fd2df5f11.woff";